import type { ComponentProps } from "react"

import { cn } from "@/lib/utils"
export const DashboardContainer = (props: ComponentProps<"div">) => {
  return (
    <main
      className={cn("flex w-full flex-1 flex-col", props.className)}
      {...props}
    />
  )
}
